import { courseClassApi } from '@/api/admin/course-class';
import { CourseClassMode } from '@/hooks/enums';
import type { RootState } from '@/store';
import type { PayloadAction } from '@reduxjs/toolkit';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import type { ICourseClassInitialState, IThunkAPI } from '@/store/types';
import type { ICourseClass } from '@/store/admin/types/types';

const initialState: ICourseClassInitialState = {
  classFormMode: CourseClassMode.none,
  classList: [],
  selectedCourseId: 0,
  selectedClassId: 0,
  selectedClass: null,
};

export const getClassListByCourseId = createAsyncThunk<any, number, IThunkAPI>(
  'get/course/class/list/courseId',
  async (courseId, thunkAPI) => {
    try {
      const response = await courseClassApi.getCourseClassByCourseId(courseId);

      return response.data;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.response.data);
    }
  },
);

export const saveCourseClass = createAsyncThunk<any, ICourseClass, IThunkAPI>(
  'post/course/class/',
  async (courseClass, thunkAPI) => {
    try {
      const response = await courseClassApi.saveCourseClass(courseClass);
      return response.data;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.response.data);
    }
  },
);

export const courseClassSlice = createSlice({
  name: 'courseClassSlice',
  initialState,
  reducers: {
    toggleClassFormMode(state, action: PayloadAction<CourseClassMode>) {
      state.classFormMode = action.payload;
    },
    setCourseId(state, action: PayloadAction<number>) {
      state.selectedCourseId = action.payload;
    },
    setClassId(state, action: PayloadAction<number>) {
      state.selectedClassId = action.payload;
    },
    setClass(state, action: PayloadAction<ICourseClass>) {
      state.selectedClass = action.payload;
    },
    clearClassId(state) {
      state.selectedClassId = 0;
    },
    clearClass(state) {
      state.selectedClass = null;
    },
  },
  extraReducers: builder => {
    builder.addCase(getClassListByCourseId.fulfilled, (state, action) => {
      state.classList = action.payload;
    });
  },
});

// actions
export const { toggleClassFormMode, setCourseId, setClass, setClassId, clearClass, clearClassId } =
  courseClassSlice.actions;

// selectors
export const classFormMode = (state: RootState): ICourseClassInitialState['classFormMode'] =>
  state.courseClass.classFormMode;

export default courseClassSlice.reducer;
